import { jsxs as n, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 20 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M16.416 14.3923C15.6827 13.709 15.741 12.6673 16.541 12.0673L17.666 11.2257C18.5577 10.5507 18.5577 9.45898 17.666 8.78398L16.541 7.94232C15.741 7.34232 15.6827 6.30065 16.416 5.61732C17.9993 4.13398 17.4743 2.92565 15.2577 2.92565L5.86602 2.92565C2.50768 2.91732 1.66602 3.70065 1.66602 6.85065L1.66602 13.1507C1.66602 16.3007 2.50768 17.084 5.86602 17.084L15.2493 17.084C17.4743 17.084 17.991 15.8673 16.416 14.3923Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10.834 12.5L5.83398 7.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10.8327 7.50393L10.8327 7.49644",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.66667"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6.25065 12.5039L6.25065 12.4964",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.66667"
        }
      )
    ]
  }
);
export {
  i as Content
};
